export const CART_MAX_QTY = 10;
